import injectSheet from 'react-jss';

import ChartOverlay from './component';
import styles from './styles';

export default injectSheet(styles)(ChartOverlay);
